import type { AiModelOption, AiSettingSource } from './types';

const usdFormatter = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'USD' });
const usdPreciseFormatter = new Intl.NumberFormat('pt-BR', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 4,
  maximumFractionDigits: 4,
});

/** Centavos para valores normais; 4 casas para custos pequenos (uma conversa custa frações de centavo). */
export function formatUsd(value: number | null | undefined): string {
  const amount = Number(value) || 0;
  if (amount !== 0 && Math.abs(amount) < 1) return usdPreciseFormatter.format(amount);
  return usdFormatter.format(amount);
}

/** Texto mascarado ("1.234,50") → USD; vazio = `null`; inválido = `undefined`. */
export function parseUsdText(text: string): number | null | undefined {
  const normalized = text.trim().replace(/\./g, '').replace(',', '.');
  if (!normalized) return null;
  const amount = Number(normalized);
  return Number.isFinite(amount) && amount >= 0 ? Math.round(amount * 100) / 100 : undefined;
}

export function usdToText(value: number | null | undefined): string {
  if (value === null || value === undefined) return '';
  return value.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

const tokenFormatter = new Intl.NumberFormat('pt-BR', { notation: 'compact', maximumFractionDigits: 1 });

export function formatTokens(value: number | null | undefined): string {
  return tokenFormatter.format(Number(value) || 0);
}

export const SOURCE_LABELS: Record<AiSettingSource, string> = {
  global: 'Padrão global',
  passbook: 'Passbook',
  store: 'Loja',
  user: 'Usuário',
};

/** Preço por 1M de tokens. */
export function formatModelPrice(model: Pick<AiModelOption, 'promptPrice' | 'completionPrice'>): string {
  const perMillion = (price: number) => usdFormatter.format(price * 1_000_000);
  return `${perMillion(model.promptPrice)} entrada · ${perMillion(model.completionPrice)} saída / 1M tokens`;
}

export function modelLabel(id: string | null | undefined, models: AiModelOption[] | undefined): string {
  if (!id) return '';
  return models?.find((model) => model.id === id)?.name ?? id;
}
